import React, { useState, useRef, useContext, useEffect } from "react";
import classes from "./SalesConfigPanel.module.css";
import Checkbox from "../../framework/Checkbox";
import { useSelector } from "react-redux";
import NumberInput from "../../framework/NumberInput";
import Switch from "../../framework/Switch";
import GlobalContext from "../../framework/GlobalContext";
import { executeScroll } from "../../utils/utils";
import ConfigurationContext from "./ConfigurationContext";

const OtherConfigPanel = (props) => {
  const {
    // SEARCH_BY_SALTS,
    SET_NUMBER_OF_DAYS_FOR_REPORT_DATA,
    ENABLE_SMS_NOTIFICATION,
    CONFIRM_SMS_BEFORE_SENDING,
    ENABLE_SHIFT,
    // ALLOW_MULTIPLE_SHIFT,
    // BLUR_MARGIN_ON_SALES,
    // ENABLE_BILL_BORDER,
    FORCE_REMARK_ON_BATCH_STOCK_ADJUSTMENT,
    // ENABLE_AUTO_BACKUP,
    ENABLE_SKU_BARCODE,
    // CLOSE_TAB_AFTER_SAVE,
    // ENABLE_MIGRATION,
    PLAY_SOUND_ON_ALL_ERRORS,
    // ENABLE_API_PUSH,
    STRICT_MEDICINE_SEARCH,
    // SHOW_CURRENT_STOCK_ON_AUDIT,
    // ALLOW_ADJUSTMENT_ON_STOCK_AUDIT,
    PASSWORD_ON_SAVING_TRANSACTION,
    PASSWORD_ON_EDIT_SALES,
    PASSWORD_ON_DELETE_SALES,
    PASSWORD_ON_EDIT_STAGE_ORDER,
    PASSWORD_ON_SAVING_PURCHASE_BILL,
    PASSWORD_ON_EDIT_PURCHASE,
    PASSWORD_ON_DELETE_PURCHASE,
    PASSWORD_ON_EDIT_SALES_RETURN,
    PASSWORD_ON_DELETE_SALES_RETURN,
    PASSWORD_ON_EDIT_PURCHASE_RETURN,
    PASSWORD_ON_DELETE_PURCHASE_RETURN,
    PASSWORD_ON_EDIT_PAYMENT,
    PASSWORD_ON_DELETE_PAYMENT,
    EXPIRY_ALERT_IN_DAYS,
    PAYMENT_ALERT_IN_DAYS,
    // SUPER_ADMIN_PASSWORD,
    // BACKUP_PATH,
    SET_MAXIMUM_TABS,
    MINIMUM_BARCODE_SIZE,
    SHOW_CURRENT_STOCK_IN_STOCK_AUDIT,
    ALLOW_ADJUSTMENT_DURING_STOCK_AUDIT,
    ENABLE_SHIFT_DAY_END,
    USER_INACTIVITY_DAYS,
    BACKUP_CRON,
    STRICT_VALIDATION_ON_PHONE_NUMBER,
    ENABLE_MOBILE_DEVICE_BILLING,
    ENABLE_MULTI_LOGIN_PER_USER,
  } = useSelector(
    (state) =>
      state.commonReducer.tabs[state.commonReducer.activeTabIndex].configData
  );

  const { formLabels } = useContext(ConfigurationContext);
  const { setCurrentComponent } = useContext(GlobalContext);

  // const maxSalesQuantity = useRef();
  //   useEffect(() => {
  //     if (SALES_LOOK_BACK) {
  //       saleLookBackRef.current.value = SALES_LOOK_BACK;
  //     }
  //     if (MAX_SALES_QUANTITY) {
  //       maxSalesQuantity.current.value = MAX_SALES_QUANTITY;
  //     }
  //   }, [SALES_LOOK_BACK, MAX_SALES_QUANTITY]);

  const [numberOfDaysForReportData, setNumberOfDaysForReportData] = useState(
    SET_NUMBER_OF_DAYS_FOR_REPORT_DATA
  );

  const [expiryAlertInDays, setExpiryAlertInDays] =
    useState(EXPIRY_ALERT_IN_DAYS);

  const [paymentAlertInDays, setPaymentAlertInDays] = useState(
    PAYMENT_ALERT_IN_DAYS
  );

  const [maximumTabs, setMaximumTabs] = useState(SET_MAXIMUM_TABS);

  const [minimumBarcodeSize, setMinimumBarcodeSize] =
    useState(MINIMUM_BARCODE_SIZE);

  const [userInactivityDays, setUserInactivityDays] =
    useState(USER_INACTIVITY_DAYS);

  const [backupCron, setBackupCron] = useState(BACKUP_CRON);

  const onSetSmsNotification = (value) => {
    if (!value) {
      props.handleFormChange("CONFIRM_SMS_BEFORE_SENDING", value, "others");
    }
  };

  const configNumberOFDaysForReportDataRef = useRef();
  const congifEnableSmsNotificationRef = useRef();
  const configConfirmSmsBeforeSendingRef = useRef();
  const configEnableShiftRef = useRef();
  const configEnableDayEndRef = useRef();
  const configForceRemarksOnAdjustment = useRef();
  const configEnableSKUBarcodeRef = useRef();
  const configPlaySoundOnAllErrorsRef = useRef();
  const configStrictProductSearchRef = useRef();
  const configExpiryAlertRef = useRef();
  const configPaymentAlertRef = useRef();
  const configStrictValidationOnPhoneNumberRef = useRef();
  const configPasswordOnSavingSalesBillRef = useRef();
  const configPasswordOnEditingSalesBillRef = useRef();
  const configPasswordOnDeletingSalesBillRef = useRef();
  const configPasswordOnEditStageOrderRef = useRef();
  const configPasswordOnSavingPuchaseRef = useRef();
  const configPasswordOnEditPuchaseRef = useRef();
  const configPasswordOnDeletePuchaseRef = useRef();
  const configPasswordOnEditSalesReturnRef = useRef();
  const configPasswordOnDeleteSalesReturnRef = useRef();
  const configPasswordOnEditPurchaseReturnRef = useRef();
  const configPasswordOnDeletePurchaseReturnRef = useRef();
  const configPasswordOnEditPaymentRef = useRef();
  const configPasswordOnDeletePaymentRef = useRef();
  const configShowCurrentStockInStockAuditRef = useRef();
  const configAllowAdjustmentInStockDuringAuditRef = useRef();
  const configSetMaximumTabsRef = useRef();
  const configMinimumBarcodeSizeRef = useRef();
  const configUserInactivityDaysRef = useRef();
  const configBackupCronRef = useRef();
  const configEnableMobileDeviceBillingRef = useRef();
  const configEnableMultiLoginRef = useRef();
  useEffect(() => {
    setCurrentComponent("other_config_number_of_days_for_report_data");
    configNumberOFDaysForReportDataRef.current.focus({ preventScroll: true });
  }, [setCurrentComponent]);

  return (
    <div className={classes["salesconfigpanel-main-container"]}>
      <div className={classes["salesconfig-text-style"]}>Other Settings</div>
      <div className={classes["salesconfig-sub-container"]}>
        <div className={classes["salesconfig-left-container"]}>
          <div className={classes["salesconfig-margin-section"]}>
            <div className={classes["salesconfig-margin-text"]}>
              Report Settings
            </div>
            <div className={classes["salesconfig-textbox-wrapper"]}>
              <NumberInput
                id="other_config_number_of_days_for_report_data"
                name="numberOfDaysForReportData"
                ref={configNumberOFDaysForReportDataRef}
                value={numberOfDaysForReportData}
                label={
                  formLabels?.SET_NUMBER_OF_DAYS_FOR_REPORT_DATA?.displayName
                }
                onFocus={() =>
                  setCurrentComponent(
                    "other_config_number_of_days_for_report_data"
                  )
                }
                onValueChange={(values, e) => {
                  setNumberOfDaysForReportData(values.floatValue);
                  props.handleFormChange(
                    "SET_NUMBER_OF_DAYS_FOR_REPORT_DATA",
                    values.floatValue,
                    "others"
                  );
                }}
                allowNegative={false}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_number_of_days_for_report_data",
                    down: props.isDcUser
                      ? "other_config_password_on_saving_puchase"
                      : "other_config_enable_sms_notification",
                    left: "other_config_number_of_days_for_report_data",
                    right: props.isDcUser
                      ? "other_config_password_on_saving_puchase"
                      : "other_config_enable_sms_notification",
                  }),
                }}
              />
            </div>
          </div>
          {!props.isDcUser && (
            <div className={classes["salesconfig-discount-section"]}>
              <div className={classes["salesconfig-discount-settings-text"]}>
                SMS Settings
              </div>
              <Checkbox
                id="other_config_enable_sms_notification"
                name="enableSMSNotification"
                ref={congifEnableSmsNotificationRef}
                label={formLabels?.ENABLE_SMS_NOTIFICATION?.displayName}
                checked={ENABLE_SMS_NOTIFICATION}
                onFocus={() => {
                  executeScroll(congifEnableSmsNotificationRef);
                  setCurrentComponent("other_config_enable_sms_notification");
                }}
                onChange={(e) => {
                  onSetSmsNotification(e.target.checked);
                  props.handleFormChange(
                    "ENABLE_SMS_NOTIFICATION",
                    e.target.checked,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_number_of_days_for_report_data",
                    down: ENABLE_SMS_NOTIFICATION
                      ? "other_config_confirm_sms_before_sending"
                      : "other_config_enable_shift_management",
                    left: "other_config_number_of_days_for_report_data",
                    right: ENABLE_SMS_NOTIFICATION
                      ? "other_config_confirm_sms_before_sending"
                      : "other_config_enable_shift_management",
                  }),
                }}
              />
              <Checkbox
                id="other_config_confirm_sms_before_sending"
                name="confirmSMSBeforeSending"
                ref={configConfirmSmsBeforeSendingRef}
                label={formLabels?.CONFIRM_SMS_BEFORE_SENDING?.displayName}
                checked={CONFIRM_SMS_BEFORE_SENDING}
                disabled={!ENABLE_SMS_NOTIFICATION}
                onFocus={() => {
                  executeScroll(configConfirmSmsBeforeSendingRef);
                  setCurrentComponent(
                    "other_config_confirm_sms_before_sending"
                  );
                }}
                onChange={(e) => {
                  props.handleFormChange(
                    "CONFIRM_SMS_BEFORE_SENDING",
                    e.target.checked,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_enable_sms_notification",
                    down: "other_config_enable_shift_management",
                    left: "other_config_enable_sms_notification",
                    right: "other_config_enable_shift_management",
                  }),
                }}
              />
            </div>
          )}
          {!props.isDcUser && (
            <div className={classes["salesconfig-rates-section"]}>
              <div className={classes["salesconfig-discount-settings-text"]}>
                Shift Settings
              </div>
              <Checkbox
                id="other_config_enable_shift_management"
                name="enableShift"
                ref={configEnableShiftRef}
                label={formLabels?.ENABLE_SHIFT?.displayName}
                checked={ENABLE_SHIFT}
                onFocus={() => {
                  executeScroll(configEnableShiftRef);
                  setCurrentComponent("other_config_enable_shift_management");
                }}
                onChange={(e) => {
                  props.handleFormChange(
                    "ENABLE_SHIFT",
                    e.target.checked,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: ENABLE_SMS_NOTIFICATION
                      ? "other_config_confirm_sms_before_sending"
                      : "other_config_enable_sms_notification",
                    down: ENABLE_SHIFT
                      ? "other_config_enable_shift_day_end"
                      : "other_config_force_remark_on_batch_stock_adjustment",
                    left: ENABLE_SMS_NOTIFICATION
                      ? "other_config_confirm_sms_before_sending"
                      : "other_config_enable_sms_notification",
                    right: ENABLE_SHIFT
                      ? "other_config_enable_shift_day_end"
                      : "other_config_force_remark_on_batch_stock_adjustment",
                  }),
                }}
              />
              <br />
              <Switch
                id="other_config_enable_shift_day_end"
                name="enableShiftDayEnd"
                label={formLabels?.ENABLE_SHIFT_DAY_END?.displayName}
                ref={configEnableDayEndRef}
                checked={ENABLE_SHIFT_DAY_END}
                onFocus={() => {
                  executeScroll(configEnableDayEndRef);
                  setCurrentComponent("other_config_enable_shift_day_end");
                }}
                onChange={(e) => {
                  props.handleFormChange(
                    "ENABLE_SHIFT_DAY_END",
                    e.target.checked,
                    "others"
                  );
                }}
                disabled={!ENABLE_SHIFT}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_enable_shift_management",
                    down: "other_config_force_remark_on_batch_stock_adjustment",
                    left: "other_config_enable_shift_management",
                    right:
                      "other_config_force_remark_on_batch_stock_adjustment",
                  }),
                }}
              />
            </div>
          )}
          {!props.isDcUser && (
            <div className={classes["salesconfig-rates-section"]}>
              <div className={classes["salesconfig-discount-settings-text"]}>
                Utility Settings
              </div>
              <Checkbox
                id="other_config_force_remark_on_batch_stock_adjustment"
                name="forceRemarkOnBatchStockAdjustment"
                label={
                  formLabels?.FORCE_REMARK_ON_BATCH_STOCK_ADJUSTMENT
                    ?.displayName
                }
                ref={configForceRemarksOnAdjustment}
                checked={FORCE_REMARK_ON_BATCH_STOCK_ADJUSTMENT}
                onFocus={() => {
                  executeScroll(configForceRemarksOnAdjustment);
                  setCurrentComponent(
                    "other_config_force_remark_on_batch_stock_adjustment"
                  );
                }}
                onChange={(e) => {
                  props.handleFormChange(
                    "FORCE_REMARK_ON_BATCH_STOCK_ADJUSTMENT",
                    e.target.checked,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: ENABLE_SHIFT
                      ? "other_config_enable_shift_day_end"
                      : "other_config_enable_shift_management",
                    down: "other_config_enable_sku_barcode",
                    left: ENABLE_SHIFT
                      ? "other_config_enable_shift_day_end"
                      : "other_config_enable_shift_management",
                    right: "other_config_enable_sku_barcode",
                  }),
                }}
              />
              <Checkbox
                id="other_config_enable_sku_barcode"
                name="enableSKUBarcode"
                label={formLabels?.ENABLE_SKU_BARCODE?.displayName}
                checked={ENABLE_SKU_BARCODE}
                ref={configEnableSKUBarcodeRef}
                onFocus={() => {
                  executeScroll(configEnableSKUBarcodeRef);
                  setCurrentComponent("other_config_enable_sku_barcode");
                }}
                onChange={(e) => {
                  props.handleFormChange(
                    "ENABLE_SKU_BARCODE",
                    e.target.checked,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_force_remark_on_batch_stock_adjustment",
                    down: "other_config_play_sound_on_all_errors",
                    left: "other_config_force_remark_on_batch_stock_adjustment",
                    right: "other_config_play_sound_on_all_errors",
                  }),
                }}
              />

              <Checkbox
                id="other_config_play_sound_on_all_errors"
                name="playSoundOnAllErrors"
                label={formLabels?.PLAY_SOUND_ON_ALL_ERRORS?.displayName}
                ref={configPlaySoundOnAllErrorsRef}
                checked={PLAY_SOUND_ON_ALL_ERRORS}
                onFocus={() => {
                  executeScroll(configPlaySoundOnAllErrorsRef);
                  setCurrentComponent("other_config_play_sound_on_all_errors");
                }}
                onChange={(e) => {
                  props.handleFormChange(
                    "PLAY_SOUND_ON_ALL_ERRORS",
                    e.target.checked,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_enable_sku_barcode",
                    down: "other_config_strict_product_search",
                    left: "other_config_enable_sku_barcode",
                    right: "other_config_strict_product_search",
                  }),
                }}
              />

              <Checkbox
                id="other_config_strict_product_search"
                name="strictMedicineSearch"
                ref={configStrictProductSearchRef}
                label={formLabels?.STRICT_MEDICINE_SEARCH?.displayName}
                checked={STRICT_MEDICINE_SEARCH}
                onFocus={() => {
                  executeScroll(configStrictProductSearchRef);
                  setCurrentComponent("other_config_strict_product_search");
                }}
                onChange={(e) => {
                  // setStrictMedicineSearch(e.target.checked);
                  props.handleFormChange(
                    "STRICT_MEDICINE_SEARCH",
                    e.target.checked,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_play_sound_on_all_errors",
                    down: "other_config_expiry_alert",
                    left: "other_config_play_sound_on_all_errors",
                    right: "other_config_expiry_alert",
                  }),
                }}
              />
            </div>
          )}
          {!props.isDcUser && (
            <div className={classes["salesconfig-stocksetting-section"]}>
              <div className={classes["salesconfig-stocksetting-text"]}>
                Notification Settings
              </div>
              <div className={classes["salesconfig-textbox-wrapper"]}>
                <NumberInput
                  id="other_config_expiry_alert"
                  name="expiryAlert"
                  value={expiryAlertInDays}
                  ref={configExpiryAlertRef}
                  label={formLabels?.EXPIRY_ALERT_IN_DAYS?.displayName}
                  onFocus={() => {
                    executeScroll(configExpiryAlertRef);
                    setCurrentComponent("other_config_expiry_alert");
                  }}
                  onValueChange={(values, e) => {
                    setExpiryAlertInDays(values.floatValue);
                    props.handleFormChange(
                      "EXPIRY_ALERT_IN_DAYS",
                      values.floatValue,
                      "others"
                    );
                  }}
                  inputProps={{
                    "data-markers": JSON.stringify({
                      up: "other_config_strict_product_search",
                      down: "other_config_payment_alert",
                      left: "other_config_strict_product_search",
                      right: "other_config_payment_alert",
                    }),
                  }}
                />
              </div>
              <div className={classes["salesconfig-textbox-wrapper"]}>
                <NumberInput
                  id="other_config_payment_alert"
                  name="paymentAlert"
                  value={paymentAlertInDays}
                  ref={configPaymentAlertRef}
                  label={formLabels?.PAYMENT_ALERT_IN_DAYS?.displayName}
                  onFocus={() => {
                    executeScroll(configPaymentAlertRef);
                    setCurrentComponent("other_config_payment_alert");
                  }}
                  onValueChange={(values, e) => {
                    setPaymentAlertInDays(values.floatValue);
                    props.handleFormChange(
                      "PAYMENT_ALERT_IN_DAYS",
                      values.floatValue,
                      "others"
                    );
                  }}
                  inputProps={{
                    "data-markers": JSON.stringify({
                      up: "other_config_expiry_alert",
                      down: "other_config_strict_validation_phone_number",
                      left: "other_config_expiry_alert",
                      right: "other_config_strict_validation_phone_number",
                    }),
                  }}
                />
              </div>
            </div>
          )}
          {!props.isDcUser && (
            <div className={classes["salesconfig-stocksetting-section"]}>
              <div className={classes["salesconfig-stocksetting-text"]}>
                Data Validation
              </div>
              <div className={classes["salesconfig-textbox-wrapper"]}>
                <Switch
                  id="other_config_strict_validation_phone_number"
                  name="StrictValidationForPhoneNumber"
                  ref={configStrictValidationOnPhoneNumberRef}
                  checked={STRICT_VALIDATION_ON_PHONE_NUMBER}
                  label={
                    formLabels?.STRICT_VALIDATION_ON_PHONE_NUMBER?.displayName
                  }
                  onFocus={() => {
                    executeScroll(configStrictValidationOnPhoneNumberRef);
                    setCurrentComponent(
                      "other_config_strict_validation_phone_number"
                    );
                  }}
                  onChange={(e) =>
                    props.handleFormChange(
                      "STRICT_VALIDATION_ON_PHONE_NUMBER",
                      e.target.checked,
                      "others"
                    )
                  }
                  inputProps={{
                    "data-markers": JSON.stringify({
                      up: "other_config_payment_alert",
                      down: "other_config_strict_validation_phone_number",
                      left: "other_config_payment_alert",
                      right: "other_config_password_on_saving_sales_bill",
                    }),
                  }}
                ></Switch>
              </div>
            </div>
          )}
        </div>
        <div className={classes["salesconfig-right-container"]}>
          <div className={classes["salesconfig-stocksetting-section"]}>
            <div className={classes["salesconfig-stocksetting-text"]}>
              Required Passwords on
            </div>
            {!props.isDcUser && (
              <Checkbox
                id="other_config_password_on_saving_sales_bill"
                name="passwordOnSavingSalesBill"
                ref={configPasswordOnSavingSalesBillRef}
                label={formLabels?.PASSWORD_ON_SAVING_TRANSACTION?.displayName}
                checked={PASSWORD_ON_SAVING_TRANSACTION}
                onFocus={() => {
                  executeScroll(configPasswordOnSavingSalesBillRef);
                  setCurrentComponent(
                    "other_config_password_on_saving_sales_bill"
                  );
                }}
                onChange={(e) => {
                  props.handleFormChange(
                    "PASSWORD_ON_SAVING_TRANSACTION",
                    e.target.checked,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_password_on_saving_sales_bill",
                    down: "other_config_password_on_editing_sales_bill",
                    left: "other_config_strict_validation_phone_number",
                    right: "other_config_password_on_editing_sales_bill",
                  }),
                }}
              />
            )}
            {!props.isDcUser && (
              <Checkbox
                id="other_config_password_on_editing_sales_bill"
                name="passwordOnEditingSalesBill"
                ref={configPasswordOnEditingSalesBillRef}
                label={formLabels?.PASSWORD_ON_EDIT_SALES?.displayName}
                checked={PASSWORD_ON_EDIT_SALES}
                onFocus={() => {
                  executeScroll(configPasswordOnEditingSalesBillRef);
                  setCurrentComponent(
                    "other_config_password_on_editing_sales_bill"
                  );
                }}
                onChange={(e) => {
                  props.handleFormChange(
                    "PASSWORD_ON_EDIT_SALES",
                    e.target.checked,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_password_on_saving_sales_bill",
                    down: "other_config_password_on_deleting_sales_bill",
                    left: "other_config_password_on_saving_sales_bill",
                    right: "other_config_password_on_deleting_sales_bill",
                  }),
                }}
              />
            )}
            {!props.isDcUser && (
              <Checkbox
                id="other_config_password_on_deleting_sales_bill"
                name="passwordOnDeletingSalesBill"
                ref={configPasswordOnDeletingSalesBillRef}
                label={formLabels?.PASSWORD_ON_DELETE_SALES?.displayName}
                checked={PASSWORD_ON_DELETE_SALES}
                onFocus={() => {
                  executeScroll(configPasswordOnDeletingSalesBillRef);
                  setCurrentComponent(
                    "other_config_password_on_deleting_sales_bill"
                  );
                }}
                onChange={(e) => {
                  //  setPasswordOnDeleteSales(e.target.checked);
                  props.handleFormChange(
                    "PASSWORD_ON_DELETE_SALES",
                    e.target.checked,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_password_on_editing_sales_bill",
                    down: "other_config_password_on_edit_stage_order",
                    left: "other_config_password_on_editing_sales_bill",
                    right: "other_config_password_on_edit_stage_order",
                  }),
                }}
              />
            )}
            {!props.isDcUser && (
              <Checkbox
                id="other_config_password_on_edit_stage_order"
                name="passwordOnEditStageOrder"
                ref={configPasswordOnEditStageOrderRef}
                label={formLabels?.PASSWORD_ON_EDIT_STAGE_ORDER?.displayName}
                checked={PASSWORD_ON_EDIT_STAGE_ORDER}
                onFocus={() => {
                  executeScroll(configPasswordOnEditStageOrderRef);
                  setCurrentComponent(
                    "other_config_password_on_edit_stage_order"
                  );
                }}
                onChange={(e) => {
                  props.handleFormChange(
                    "PASSWORD_ON_EDIT_STAGE_ORDER",
                    e.target.checked,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_password_on_deleting_sales_bill",
                    down: "other_config_password_on_saving_puchase",
                    left: "other_config_password_on_deleting_sales_bill",
                    right: "other_config_password_on_saving_puchase",
                  }),
                }}
              />
            )}
            <Checkbox
              id="other_config_password_on_saving_puchase"
              name="passwordOnSavingPurchase"
              ref={configPasswordOnSavingPuchaseRef}
              label={formLabels?.PASSWORD_ON_SAVING_PURCHASE_BILL?.displayName}
              checked={PASSWORD_ON_SAVING_PURCHASE_BILL}
              onFocus={() => {
                executeScroll(configPasswordOnSavingPuchaseRef);
                setCurrentComponent("other_config_password_on_saving_puchase");
              }}
              onChange={(e) => {
                props.handleFormChange(
                  "PASSWORD_ON_SAVING_PURCHASE_BILL",
                  e.target.checked,
                  "others"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: props.isDcUser
                    ? "other_config_number_of_days_for_report_data"
                    : "other_config_password_on_edit_stage_order",
                  down: "other_config_password_on_edit_puchase",
                  left: props.isDcUser
                    ? "other_config_number_of_days_for_report_data"
                    : "other_config_password_on_edit_stage_order",
                  right: "other_config_password_on_edit_puchase",
                }),
              }}
            />
            <Checkbox
              id="other_config_password_on_edit_puchase"
              name="passwordOnEditPurchase"
              ref={configPasswordOnEditPuchaseRef}
              label={formLabels?.PASSWORD_ON_EDIT_PURCHASE?.displayName}
              checked={PASSWORD_ON_EDIT_PURCHASE}
              onFocus={() => {
                executeScroll(configPasswordOnEditPuchaseRef);
                setCurrentComponent("other_config_password_on_edit_puchase");
              }}
              onChange={(e) => {
                props.handleFormChange(
                  "PASSWORD_ON_EDIT_PURCHASE",
                  e.target.checked,
                  "others"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "other_config_password_on_saving_puchase",
                  down: "other_config_password_on_delete_puchase",
                  left: "other_config_password_on_saving_puchase",
                  right: "other_config_password_on_delete_puchase",
                }),
              }}
            />
            <Checkbox
              id="other_config_password_on_delete_puchase"
              name="passwordOnDeletePurchase"
              ref={configPasswordOnDeletePuchaseRef}
              label={formLabels?.PASSWORD_ON_DELETE_PURCHASE?.displayName}
              checked={PASSWORD_ON_DELETE_PURCHASE}
              onFocus={() => {
                executeScroll(configPasswordOnDeletePuchaseRef);
                setCurrentComponent("other_config_password_on_delete_puchase");
              }}
              onChange={(e) => {
                props.handleFormChange(
                  "PASSWORD_ON_DELETE_PURCHASE",
                  e.target.checked,
                  "others"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "other_config_password_on_edit_puchase",
                  down: props.isDcUser
                    ? "other_config_set_maximum_tabs"
                    : "other_config_password_on_edit_sales_returns",
                  left: "other_config_password_on_edit_puchase",
                  right: props.isDcUser
                    ? "other_config_set_maximum_tabs"
                    : "other_config_password_on_edit_sales_returns",
                }),
              }}
            />
            {!props.isDcUser && (
              <Checkbox
                id="other_config_password_on_edit_sales_returns"
                name="passwordOnEditSalesReturn"
                ref={configPasswordOnEditSalesReturnRef}
                label={formLabels?.PASSWORD_ON_EDIT_SALES_RETURN?.displayName}
                checked={PASSWORD_ON_EDIT_SALES_RETURN}
                onFocus={() => {
                  executeScroll(configPasswordOnEditSalesReturnRef);
                  setCurrentComponent(
                    "other_config_password_on_edit_sales_returns"
                  );
                }}
                onChange={(e) => {
                  props.handleFormChange(
                    "PASSWORD_ON_EDIT_SALES_RETURN",
                    e.target.checked,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_password_on_delete_puchase",
                    down: "other_config_password_on_delete_sales_return",
                    left: "other_config_password_on_delete_puchase",
                    right: "other_config_password_on_delete_sales_return",
                  }),
                }}
              />
            )}
            {!props.isDcUser && (
              <Checkbox
                id="other_config_password_on_delete_sales_return"
                name="passwordonDeleteSalesReturn"
                ref={configPasswordOnDeleteSalesReturnRef}
                label={formLabels?.PASSWORD_ON_DELETE_SALES_RETURN?.displayName}
                checked={PASSWORD_ON_DELETE_SALES_RETURN}
                onFocus={() => {
                  executeScroll(configPasswordOnDeleteSalesReturnRef);
                  setCurrentComponent(
                    "other_config_password_on_delete_sales_return"
                  );
                }}
                onChange={(e) => {
                  props.handleFormChange(
                    "PASSWORD_ON_DELETE_SALES_RETURN",
                    e.target.checked,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_password_on_edit_sales_returns",
                    down: "other_config_password_on_edit_purchase_returns",
                    left: "other_config_password_on_edit_sales_returns",
                    right: "other_config_password_on_edit_purchase_returns",
                  }),
                }}
              />
            )}
            {!props.isDcUser && (
              <Checkbox
                id="other_config_password_on_edit_purchase_returns"
                name="passwordOnEditPurchaseReturn"
                ref={configPasswordOnEditPurchaseReturnRef}
                label={
                  formLabels?.PASSWORD_ON_EDIT_PURCHASE_RETURN?.displayName
                }
                checked={PASSWORD_ON_EDIT_PURCHASE_RETURN}
                onFocus={() => {
                  executeScroll(configPasswordOnEditPurchaseReturnRef);
                  setCurrentComponent(
                    "other_config_password_on_edit_purchase_returns"
                  );
                }}
                onChange={(e) => {
                  props.handleFormChange(
                    "PASSWORD_ON_EDIT_PURCHASE_RETURN",
                    e.target.checked,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_password_on_delete_sales_return",
                    down: "other_config_password_on_delete_purchase_return",
                    left: "other_config_password_on_delete_sales_return",
                    right: "other_config_password_on_delete_purchase_return",
                  }),
                }}
              />
            )}
            {!props.isDcUser && (
              <Checkbox
                id="other_config_password_on_delete_purchase_return"
                name="passwordOnDeletePurchaseReturn"
                ref={configPasswordOnDeletePurchaseReturnRef}
                label={
                  formLabels?.PASSWORD_ON_DELETE_PURCHASE_RETURN?.displayName
                }
                checked={PASSWORD_ON_DELETE_PURCHASE_RETURN}
                onFocus={() => {
                  executeScroll(configPasswordOnDeletePurchaseReturnRef);
                  setCurrentComponent(
                    "other_config_password_on_delete_purchase_return"
                  );
                }}
                onChange={(e) => {
                  props.handleFormChange(
                    "PASSWORD_ON_DELETE_PURCHASE_RETURN",
                    e.target.checked,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_password_on_edit_purchase_returns",
                    down: "other_config_password_on_edit_payment",
                    left: "other_config_password_on_edit_purchase_returns",
                    right: "other_config_password_on_edit_payment",
                  }),
                }}
              />
            )}
            {!props.isDcUser && (
              <Checkbox
                id="other_config_password_on_edit_payment"
                name="passwordOnEditPayment"
                ref={configPasswordOnEditPaymentRef}
                label={formLabels?.PASSWORD_ON_EDIT_PAYMENT?.displayName}
                checked={PASSWORD_ON_EDIT_PAYMENT}
                onFocus={() => {
                  executeScroll(configPasswordOnEditPaymentRef);
                  setCurrentComponent("other_config_password_on_edit_payment");
                }}
                onChange={(e) => {
                  props.handleFormChange(
                    "PASSWORD_ON_EDIT_PAYMENT",
                    e.target.checked,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_password_on_delete_purchase_return",
                    down: "other_config_password_on_delete_payment",
                    left: "other_config_password_on_delete_purchase_return",
                    right: "other_config_password_on_delete_payment",
                  }),
                }}
              />
            )}
            {!props.isDcUser && (
              <Checkbox
                id="other_config_password_on_delete_payment"
                name="passwordOnDeletePayment"
                ref={configPasswordOnDeletePaymentRef}
                label={formLabels?.PASSWORD_ON_DELETE_PAYMENT?.displayName}
                checked={PASSWORD_ON_DELETE_PAYMENT}
                onFocus={() => {
                  executeScroll(configPasswordOnDeletePaymentRef);
                  setCurrentComponent(
                    "other_config_password_on_delete_payment"
                  );
                }}
                onChange={(e) => {
                  props.handleFormChange(
                    "PASSWORD_ON_DELETE_PAYMENT",
                    e.target.checked,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_password_on_edit_payment",
                    down: "other_config_show_current_stock_in_stock_audits",
                    left: "other_config_password_on_edit_payment",
                    right: "other_config_show_current_stock_in_stock_audits",
                  }),
                }}
              />
            )}
          </div>
          {!props.isDcUser && (
            <div className={classes["salesconfig-stocksetting-section"]}>
              <div className={classes["salesconfig-stocksetting-text"]}>
                Stock Audit
              </div>
              <Checkbox
                id="other_config_show_current_stock_in_stock_audits"
                name="showCurrentStockInStockAudit"
                ref={configShowCurrentStockInStockAuditRef}
                label={
                  formLabels?.SHOW_CURRENT_STOCK_IN_STOCK_AUDIT?.displayName
                }
                checked={SHOW_CURRENT_STOCK_IN_STOCK_AUDIT}
                onFocus={() => {
                  executeScroll(configShowCurrentStockInStockAuditRef);
                  setCurrentComponent(
                    "other_config_show_current_stock_in_stock_audits"
                  );
                }}
                onChange={(e) => {
                  props.handleFormChange(
                    "SHOW_CURRENT_STOCK_IN_STOCK_AUDIT",
                    e.target.checked,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_password_on_delete_payment",
                    down: "other_config_allow_adjustment_in_stock_during_audit",
                    left: "other_config_password_on_delete_payment",
                    right:
                      "other_config_allow_adjustment_in_stock_during_audit",
                  }),
                }}
              />
              <Checkbox
                id="other_config_allow_adjustment_in_stock_during_audit"
                name="allowAdjustmentInStockDuringAudit"
                ref={configAllowAdjustmentInStockDuringAuditRef}
                label={
                  formLabels?.ALLOW_ADJUSTMENT_DURING_STOCK_AUDIT?.displayName
                }
                checked={ALLOW_ADJUSTMENT_DURING_STOCK_AUDIT}
                onFocus={() => {
                  executeScroll(configAllowAdjustmentInStockDuringAuditRef);
                  setCurrentComponent(
                    "other_config_allow_adjustment_in_stock_during_audit"
                  );
                }}
                onChange={(e) => {
                  props.handleFormChange(
                    "ALLOW_ADJUSTMENT_DURING_STOCK_AUDIT",
                    e.target.checked,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_show_current_stock_in_stock_audits",
                    down: "other_config_set_maximum_tabs",
                    left: "other_config_show_current_stock_in_stock_audits",
                    right: "other_config_set_maximum_tabs",
                  }),
                }}
              />
            </div>
          )}
          <div className={classes["salesconfig-stocksetting-section"]}>
            <div className={classes["salesconfig-stocksetting-text"]}>
              Miscellaneous
            </div>
            <div className={classes["salesconfig-textbox-wrapper"]}>
              <NumberInput
                id="other_config_set_maximum_tabs"
                name="setMaximumTabs"
                value={maximumTabs}
                ref={configSetMaximumTabsRef}
                label={formLabels?.SET_MAXIMUM_TABS?.displayName}
                onFocus={() => {
                  executeScroll(configSetMaximumTabsRef);
                  setCurrentComponent("other_config_set_maximum_tabs");
                }}
                onValueChange={(values, e) => {
                  setMaximumTabs(values.floatValue);
                  props.handleFormChange(
                    "SET_MAXIMUM_TABS",
                    values.floatValue,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: props.isDcUser
                      ? "other_config_password_on_delete_puchase"
                      : "other_config_allow_adjustment_in_stock_during_audit",
                    down: "other_config_minimum_barcode_size",
                    left: props.isDcUser
                      ? "other_config_password_on_delete_puchase"
                      : "other_config_allow_adjustment_in_stock_during_audit",
                    right: "other_config_minimum_barcode_size",
                  }),
                }}
              />
            </div>
            <div className={classes["salesconfig-textbox-wrapper"]}>
              <NumberInput
                id="other_config_minimum_barcode_size"
                name="minimumBarcodeSize"
                value={minimumBarcodeSize}
                ref={configMinimumBarcodeSizeRef}
                label={formLabels?.MINIMUM_BARCODE_SIZE?.displayName}
                onFocus={() => {
                  executeScroll(configMinimumBarcodeSizeRef);
                  setCurrentComponent("other_config_minimum_barcode_size");
                }}
                onValueChange={(values, e) => {
                  setMinimumBarcodeSize(values.floatValue);
                  props.handleFormChange(
                    "MINIMUM_BARCODE_SIZE",
                    values.floatValue,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_set_maximum_tabs",
                    down: "other_config_user_inactivity_days",
                    left: "other_config_set_maximum_tabs",
                    right: "other_config_user_inactivity_days",
                  }),
                }}
              />
            </div>
            <div className={classes["salesconfig-textbox-wrapper"]}>
              <NumberInput
                id="other_config_user_inactivity_days"
                name="userInactivityDays"
                value={userInactivityDays}
                ref={configUserInactivityDaysRef}
                label={formLabels?.USER_INACTIVITY_DAYS?.displayName}
                onFocus={() => {
                  executeScroll(configUserInactivityDaysRef);
                  setCurrentComponent("other_config_user_inactivity_days");
                }}
                onValueChange={(values, e) => {
                  setUserInactivityDays(values.floatValue);
                  props.handleFormChange(
                    "USER_INACTIVITY_DAYS",
                    values.floatValue,
                    "others"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_minimum_barcode_size",
                    down: "other_config_backup_cron",
                    left: "other_config_minimum_barcode_size",
                    right: "other_config_backup_cron",
                  }),
                }}
              />
            </div>
            <div className={classes["salesconfig-textbox-wrapper"]}>
              <NumberInput
                id="other_config_backup_cron"
                name="backupCron"
                value={backupCron}
                ref={configBackupCronRef}
                label={formLabels?.BACKUP_CRON?.displayName}
                allowNegative={false}
                onValueChange={(values, e) => {
                  let _value = 0;
                  if (values.floatValue) {
                    _value = values.floatValue;
                  }
                  setBackupCron(_value);
                  props.handleFormChange("BACKUP_CRON", _value, "others");
                }}
                onFocus={() => {
                  executeScroll(configBackupCronRef);
                  setCurrentComponent("other_config_backup_cron");
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "other_config_user_inactivity_days",
                    down: props.isDcUser
                      ? "other_config_backup_cron"
                      : "other_config_enable_mobile_device_billing",
                    left: "other_config_user_inactivity_days",
                    right: props.isDcUser
                      ? "other_config_enable_mobile_device_billing"
                      : "other_config_enable_mobile_device_billing",
                  }),
                }}
                isAllowed={(values) => {
                  const { formattedValue } = values;
                  return formattedValue >= 0 && formattedValue <= 24;
                }}
              />
            </div>
            {!props.isDcUser && (
              <div className={classes["salesconfig-textbox-wrapper"]}>
                <Checkbox
                  id="other_config_enable_mobile_device_billing"
                  name="enableMobileDeviceBilling"
                  label={formLabels?.ENABLE_MOBILE_DEVICE_BILLING?.displayName}
                  ref={configEnableMobileDeviceBillingRef}
                  checked={ENABLE_MOBILE_DEVICE_BILLING}
                  onChange={(e) => {
                    props.handleFormChange(
                      "ENABLE_MOBILE_DEVICE_BILLING",
                      e.target.checked,
                      "others"
                    );
                  }}
                  onFocus={() => {
                    executeScroll(configEnableMobileDeviceBillingRef);
                    setCurrentComponent(
                      "other_config_enable_mobile_device_billing"
                    );
                  }}
                  inputProps={{
                    "data-markers": JSON.stringify({
                      up: "other_config_backup_cron",
                      down: "other_config_enable_multi_login_per_user",
                      left: "other_config_backup_cron",
                      right: "other_config_enable_multi_login_per_user",
                    }),
                  }}
                />
                <Checkbox
                  id="other_config_enable_multi_login_per_user"
                  name="enableMultiLoginPerUser"
                  label={formLabels?.ENABLE_MULTI_LOGIN_PER_USER?.displayName}
                  ref={configEnableMultiLoginRef}
                  checked={ENABLE_MULTI_LOGIN_PER_USER}
                  onChange={(e) => {
                    props.handleFormChange(
                      "ENABLE_MULTI_LOGIN_PER_USER",
                      e.target.checked,
                      "others"
                    );
                  }}
                  onFocus={() => {
                    executeScroll(configEnableMultiLoginRef);
                    setCurrentComponent(
                      "other_config_enable_multi_login_per_user"
                    );
                  }}
                  inputProps={{
                    "data-markers": JSON.stringify({
                      up: "other_config_enable_mobile_device_billing",
                      down: "other_config_enable_multi_login_per_user",
                      left: "other_config_enable_mobile_device_billing",
                      right: "other_config_enable_multi_login_per_user",
                    }),
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherConfigPanel;
